import {useEffect, useState} from "react";
import {isEmpty} from "es-toolkit/compat";

const INITIAL_STATE = {
  isNativeApp: false,
  isDesktop: false,
  isMobile: false,
  isTablet: false,
  isIOS: false,
  isAndroid: false,
};

export const useDevice = () => {
  const [env, setEnv] = useState(INITIAL_STATE);
  const isNativeApp = window.median !== undefined || navigator.userAgent.indexOf("median") > -1;
  const isUserAgent = navigator.userAgent !== undefined;

  useEffect(() => {
    if (isUserAgent) {
      const isIOS = Boolean(navigator.userAgent?.match(/iPhone|iPad|iPod/i));
      const isAndroid = Boolean(navigator.userAgent?.match(/Android/i));
      const isMobile =
        isIOS || isAndroid || navigator.userAgent?.match(/BlackBerry/i) || navigator.userAgent?.match(/Windows Phone/i);

      const newEnv = {
        ...env,
        isIOS,
        isAndroid,
        isMobile,
        isDesktop: !isMobile,
      };

      setEnv(prevValue => ({...prevValue, ...newEnv}));
    }

    if (isNativeApp) {
      let deviceInfo = window.median?.run.deviceInfo();

      if (!deviceInfo || isEmpty(deviceInfo)) {
        deviceInfo = getDeviceInfoPromise();
      }

      const isIOS = deviceInfo?.platform === "ios" || Boolean(navigator.userAgent?.match(/iPhone|iPad|iPod/i)) || false;
      const isAndroid = deviceInfo?.platform === "android" || Boolean(navigator.userAgent?.match(/Android/i)) || false;
      const isMobile = isIOS || isAndroid || isNativeApp || false;
      const isDesktop = !isMobile;

      const newEnv = {
        ...env,
        isNativeApp: true,
        isAndroid,
        isIOS,
        isMobile,
        isDesktop,
      };

      setEnv(prevValue => ({...prevValue, ...newEnv}));
    }
  }, [isNativeApp, isUserAgent]);

  const getDeviceInfoPromise = async () => {
    const deviceInfo = await window?.median?.deviceInfo();
    return deviceInfo;
  };

  return env;
};
